<template>
  <v-layout v-if="!reviewable">
    <h2 class="subheading">
      This option is only available once a shift has begun.
    </h2>
  </v-layout>

  <v-layout v-else column class="pa-2">
    <v-flex grow v-if="!anyReviews && !canAuthor" class="subheading">
      Only clients can write shift reviews. If there are any reviews written and
      you have permission to see them, they will appear here.
    </v-flex>

    <v-flex grow v-if="!anyReviews && canAuthor">
      <v-form>
        <label aria-hidden="true" class="v-label theme--light" style="left: 0px; right: auto; position: relative;">Rating</label>
        <v-rating
          half-increments
          hover
          large
          label="Rating"
          v-model="newReview.rating"
          length="4"
        ></v-rating>
        <v-textarea
          v-model="newReview.review"
          label="Review"
        ></v-textarea>
        <v-layout row justify-space-between>
          <v-flex justify-end class="text-xs-right">
            <div>
              <span class="subtle font-italic">Reviewed by {{ user.displayName }}</span>
            </div>
            <div>
              <span class="subtle font-italic">On {{ new Date() | moment("dddd, MMM Do") }}</span>
            </div>
            <div>
              <v-btn color='success' :loading="posting" :disabled="posting" @click="createReview">Submit</v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>

    <v-flex v-else>
      <v-layout row>
        <v-flex v-for='review in reviews'>

          <v-layout column class="pa-2">
            <v-flex>
              <v-rating
                half-increments
                readonly
                large
                label="Rating"
                v-model="review.rating"
                length="4"
              ></v-rating>
            </v-flex>
            <v-flex class="subheading">
              Reviewed by: <strong>{{ review.authorName }}</strong> On {{ review.createdAt | moment("dddd, MMM Do [at] h:mma") }}
            </v-flex>
            <v-flex class="headline">
              {{ review.review }}
            </v-flex>
          </v-layout>

        </v-flex>
      </v-layout>
    </v-flex>

  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user'
    ]),
    ...mapState('shiftReviews', [
      'reviews'
    ]),
    anyReviews () {
      return (this.reviews && this.reviews.length > 0);
    },
    canAuthor () {
      return (this.user.role == 'client' && this.user.clientWorksiteIds.includes(this.shift.worksiteId));
    },
    reviewable() {
      return this.$moment(this.shift.startDatetime).isBefore(this.$moment());
    },
  },
  props: {
    shift: Object,
  },
  created () {
    this.setUp();
  },
  data () {
    return {
      posting: false,
      newReview: {
        shift_id: this.shift.id,
        rating: 0.0,
        review: '',
      },
    }
  },
  methods: {
    setUp () {
      this.$store.dispatch('shiftReviews/getForShift', this.shift.id);
    },
    createReview () {
      this.posting = true;
      this.$store.dispatch('shiftReviews/create',
        this.newReview
      ).then(res => {
        this.$store.dispatch('global/showSnackbarSuccess', { message: 'Review created!' })
      })
      .catch(res => {
        this.$store.dispatch('global/showSnackbarError', { message: 'Something went wrong creating that review' })
      })
      .finally(res => {
        this.posting = false
      })
    },
  },
}
</script>
